// extracted by mini-css-extract-plugin
export default {"cards_wrapper":"styles-module__cards_wrapper--bxrTS","item":"styles-module__item--X6ZG5","link":"styles-module__link--Jl0tP"};